import React from "react";
import { Typography } from "@mui/material";
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import Error from './Error.json'

function AppError({ error, resetErrorBoundary }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Error,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  return (
    <div>
      <Player
        autoplay
        loop
        src={Error}
        style={{ height: '70vh', width: '50vh' }}
      >
        <Controls visible={false} buttons={['play', 'repeat', 'frame', 'debug']} />
      </Player>
      <div className="textCenter">
      <Typography className="font36 fw600 colorBlue">Something Went Wrong</Typography>
      <Typography className="font28 colorGrey fw600 marginBottom7">Error Reported To Admin</Typography>
      <button className="btnSubvendor" onClick={resetErrorBoundary}>
        Try again
      </button>
      </div>
    </div>
  );
}

export default AppError;
